<template>
    <div class="home">
        <div class="login">
            <div class="login-wrap">
                <img src="https://www.carrotians.net/img/logo.5c88e56e.png">
                <p>Pronunciation Test App</p>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
// import axios from "axios";

export default {
    
    setup() {
        const router = useRouter()
        const route = useRoute()
        const store = useStore()
        const toast = useToast()

        const comp = reactive({
            user : { idx:0, uid: '', ename:'' },

            doLogin: () => {
                if( !comp.user.ename ){
                    comp.user.ename = comp.user.uid.split('@')[0]
                    // console.log(comp.user.ename)
                }

                store.commit('setUser', comp.user)

                toast.success("Hello, " + comp.user.ename + ".", ()=>{
                    router.push({ path:'/Front/List', params:{} })
                })
                setTimeout(() => {
                    router.push({ path:'/Front/List', params:{} })
                }, 1000)
            }
        })

        onMounted(() => {
            // Mounted
            if(!route.query || !route.query.idx || !route.query.uid){
                console.log(store.state.user.idx)
                if( store.state.user.idx > 0 ){
                    router.push({ path:'/Front/List', params:{} })
                    return
                }

                alert("Wrong approach!")
                self.close()
                window.open('', '_self', '')
                window.close()
                return
            }

            comp.user.idx = parseInt(route.query.idx)
            comp.user.uid = (route.query.uid)
            comp.user.ename = (!route.query.ename?'':route.query.ename)


            router.replace({}, 'signed', '/signed')

            comp.doLogin()
        })

        return { comp };
    }
};
</script>
<style lang="scss">
@import "@/scss/_variables.scss";

.home {
    .login {
        position:absolute; top:0; left:0; height:100%; min-height: 800px; width: 100%;
        background: url('https://www.carrotians.net/img/220908_login.ae582f74.png');  display: flex; align-items: center; background-size: cover; background-position: bottom;
        .login-wrap {
            padding: 70px 70px; background-color: #ffcf93; border-radius: 20px; max-width: 578px; margin: 0 auto; text-align: center;
            p {
                font-size: 18px; font-weight: 400; font-stretch: normal; font-style: normal; line-height: 1.39; letter-spacing: -.36px; text-align: center; color: #3f3f3f; margin-top: 24px;
            }
        }
    }
}
</style>
